const taskTemplates = require('data/templates/task-templates');
const {effectTemplate} = require('data/templates/effect-template');

let moduleTasks = [
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m2-bs-teacher-lunch',
			background: 'school',
			backgroundModifier: 'teachers-room-right',
			maxPoints: 3,
			text: {
				da: `I spisepausen går du ind på personalerummet for at spise frokost. Der er flere borde du kan sætte dig ved."
					<br /><br />Hvor vælger du at sætte dig?`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du sætter dig alene, så du kan spise i fred og klare hovedet inden næste time`
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det giver måske ro, men føles lidt ensomt at sidde alene.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Du finder ressourcelæreren og sætter dig ved hans bord.`
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er en god idé at sætte dig ved et bord med nogen der virker imødekommende eller du har en relation til`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Du sætter dig ved siden af den lærer, som du hilste på i morges. Han virkede imødekommende og hjælpsom`
							},
							nextStepId: 'step-4',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er en god idé at sætte dig ved et bord med nogen der virker imødekommende eller du har en relation til`
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-2',
					text: {
						da: `Du spiser frokost alene.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-3',
					text: {
						da: `"Det virkede til at du havde godt styr på klassen" smiler han. "Du må endelig sige til hvis du har brug for hjælp."`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-4',
					text: {
						da: `"Gik det okay i 2C?” “Det kan være svært som vikar," nikker læreren medfølende. “Du klarede både en konflikt og fik en god time ud af det.”`
					}
				}),
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m2-mc-small-talk',
			background: 'school',
			backgroundModifier: 'teachers-room-right',
			isDilemma: true,
			text: {
				da: `Flere lærere sætter sig og en af dem spørger dig, om du er den nye vikar og om du er faldet godt til.`,
				en: ``,
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `Du fortæller om dine oplevelser som vikar og de udfordringer du har oplevet`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er godt at du deltager i samtalen.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `Du spørger til hvordan de håndterer konflikter og lykkes med  undervisningen`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er godt at du deltager i samtalen.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `Du fortæller om dig selv og spørger til de andre ved bordet`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er godt at du deltager i samtalen.`,
									en: ``,
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m2-bs-8a-phones',
			background: 'school',
			backgroundModifier: 'classroom-8a-phones',
			maxPoints: 3,
			text: {
				da: `Du træder ind i 8.A til dagens sidste time: 'Hej - telefonerne skal i kassen som I plejer, så er vi klar til at gå i gang'.
					<br /><br />Hvordan håndterer du indleveringen af telefoner?`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Bliver stående ved døren og venter roligt.`
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `God tilgang, du bevarer overblikket og demonstrerer ro og autoritet.`,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Begynder at gå rundt i klassen med kassen til telefoner.`
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `God tilgang, der skaber kontakt til eleverne, og mulighed for lige at hilse nærmere på dem mens du samler telefonerne ind.`,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Sætter dig ved kateteret og venter.`
							},
							nextStepId: 'step-4',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Denne tilgang er meget passiv, og giver næppe det ønskede resultat, med mindre det er den rutine klassen specifikt er vandt til.`,
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-2',
					text: {
						da: `Nogle elever sukker men begynder at bevæge sig mod kassen. Din ro smitter.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-3',
					text: {
						da: `Eleverne begynder modvilligt at finde deres telefoner frem.`
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-4',
					text: {
						da: `Få elever reagerer på din besked.`
					}
				}),
			]
		}),
		Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
			taskId: 's1-m2-spot-errors-8a-issues',
			layout: 's1-m2-8a-issues',
			background: 'school',
			backgroundModifier: 'classroom-8a-issues',
			text: {
				da: `Find to ting i klasselokalet du bør være særligt opmærksom på.`,
			},
			errors: [
				Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
					id: 'phone',
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `En elev der ikke følger klassens regler kræver handling.`,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {
					id: 'snacks',
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Godt set. Dette kan hurtigt udvikle sig til en forstyrrelse, og chips i klasselokalet er typisk ikke tilladt.`,
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m2-bs-8a-phone',
			background: 'school',
			backgroundModifier: 'classroom-8a-issues',
			maxPoints: 6,
			text: {
				da: `Marie har lagt en gammel iPhone i kassen, men du kan tydeligt se lysskæret fra en nyere telefon under hendes bord.
					<br /><br />Hvordan håndterer du dette?`,
			},
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Mens klassen finder materialer frem til timen, går du hen til Marie.`
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Du tager det op med hele klassen og siger "Det ser ud til at nogle af jer måske har mere end én telefon med i dag."`
							},
							nextStepId: 'step-7',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Begynder undervisningen men holder øje.`
							},
							nextStepId: 'step-11',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Marie kigger op og ser overdrevet uskyldig ud da du nærmer dig.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Marie, jeg skal også have din anden telefon. Den kan du hente når vi er færdige.`
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du sætter en klar ramme og tydelige forventninger.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Jeg kan se du har en telefon mere - vil du selv lægge den i kassen, eller skal vi op på kontoret?`
							},
							nextStepId: 'step-5',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du sætter en klar ramme og klare forventninger. At true med noget kan i nogle situationer få eleven til at eskalere konflikten, for at se, om du gør hvad du siger. `
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Sjovt trick med den gamle telefon, men det virker ikke.`
							},
							nextStepId: 'step-6',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du får blødt stemningen op. Selv med dårlig humor fjerner du presset fra situationen.`
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-3',
					text: {
						da: `Marie sukker og fisker modvilligt den nye iPhone op af lommen.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Tak - jeg sætter pris på din ærlighed nu.`
							},
							nextStepId: 'step-4'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-4',
					text: {
						da: `Mens du går tilbage mod tavlen, kan du mærke at klassen holder øje med hvordan situationen blev håndteret.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du tager en dyb indånding, og begynder roligt på at undervise i dagens emne.`
							},
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-5',
					text: {
						da: `Marie tøver et øjeblik, så rækker hun telefonen frem.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det var en god beslutning.`
							},
							nextStepId: 'step-4'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-6',
					text: {
						da: `Marie ruller med øjnene men finder telefonen frem.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Fint, så behøver vi ikke tale mere om det.`
							},
							nextStepId: 'step-4'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-7',
					text: {
						da: `Hvordan fortsætter du?`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Jeg siger: "Jeg ved godt det kan være fristende at snyde, men lad os starte på en ærlig måde"`
							},
							nextStepId: 'step-8',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du anerkender fristelsen men appellerer til deres integritet.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Jeg siger: "Sidste chance for at aflevere alle telefoner frivilligt"`
							},
							nextStepId: 'step-9',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du giver mulighed for at rette ind, men skaber også en anspændt stemning.`
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Jeg siger: "Er det ikke lidt pinligt at prøve at snyde på den måde?"`
							},
							nextStepId: 'step-10',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `At udstille elever offentligt kan skabe modstand og gøre det sværere at få samarbejde.`
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-8',
					text: {
						da: `Der breder sig en eftertænksom stemning i klassen.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du går hen til Marie for at følge op.`
							},
							nextStepId: 'step-2'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-9',
					text: {
						da: `Enkelte elever ser nervøst på hinanden.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du går hen til Marie for at følge op.`
							},
							nextStepId: 'step-2'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-10',
					text: {
						da: `Der breder sig en defensiv stemning i klassen.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du går hen til Marie for at følge op.`
							},
							nextStepId: 'step-2'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-11',
					text: {
						da: `Marie bliver mere og mere åbenlys i sin brug af telefonen under bordet"
							<br />Hvad gør du?`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Nu går du hen til Marie.`
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Stopper undervisningen: "Marie, jeg kan se din telefon".`
							},
							nextStepId: 'step-12',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Sender en besked til kontoret.`
							},
							nextStepId: 'step-14',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Reaktionen virker overdrevet, og du underminerer din egen autoritet.`,
											en: ``,
										}
									})
								})
							]
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-12',
					text: {
						da: `Klassen følger intenst med i konfrontationen.`
					},
					nextStepId: 'step-13'
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-13',
					text: {
						da: `Marie afleverer modvilligt telefonen.`
					},
					nextStepId: 'step-4'
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-14',
					text: {
						da: `En lærer kommer og tager Marie med ud. Det skaber uro i klassen.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Du prøver at få fokus tilbage på undervisningen.`
							},
							nextStepId: 'step-4'
						}),
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
			taskId: 's1-m2-order-conflict-management',
			background: 'school',
			backgroundModifier: 'classroom-8a',
			text: {
				da: `Du har lige håndteret en potentiel konflikt. Lad os reflektere over hvordan konflikter udvikler sig. Arrangér disse trin i den korrekte rækkefølge fra start til eskalering`,
				en: ``
			},
			items: [
				Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
					id: 1,
					text: {
						da: `Uoverensstemmelse`,
						en: ``
					},
					correctOrderNumbers: [1]
				}),
				Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
					id: 2,
					text: {
						da: `Personificering får problemet til at vokse`,
						en: ``
					},
					correctOrderNumbers: [2]
				}),
				Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
					id: 3,
					text: {
						da: `Samtale opgives og fjendebilleder opstår`,
						en: ``
					},
					correctOrderNumbers: [3]
				}),
				Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
					id: 4,
					text: {
						da: `Åben fjendtlighed og der skabes polarisering`,
						en: ``
					},
					correctOrderNumbers: [4]
				})
			]
		}),
		Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
			taskId: 's1-m2-instructions-conflict-management',
			background: 'school',
			backgroundModifier: 'classroom-8a',
			text: {
				da: `Ved at forstå konflikttrappens trin bliver det nemmere at genkende og forebygge eskalering`,
			}
		}),
		Object.assign({}, taskTemplates.matchTemplate.mainTemplate, {
			taskId: 's1-m2-match-conflict',
			background: 'school',
			backgroundModifier: 'classroom-8a',
			text: {
				da: `Match hver konfliktsituation med den mest hensigtsmæssige tilgang:`,
				en: ``
			},
			categories: [
				Object.assign({}, taskTemplates.matchTemplate.categoryTemplate, {
					id: 1,
					text: {
						da: 'Elev skjuler telefon',
						en: ``
					},
					itemIds: [1]
				}),
				Object.assign({}, taskTemplates.matchTemplate.categoryTemplate, {
					id: 2,
					text: {
						da: 'Klassen udfordrer regler',
						en: ``
					},
					itemIds: [2]
				}),
				Object.assign({}, taskTemplates.matchTemplate.categoryTemplate, {
					id: 5,
					text: {
						da: 'Passiv modstand',
						en: ``
					},
					itemIds: [5]
				})		
			],
			items: [
				Object.assign({}, taskTemplates.matchTemplate.itemTemplate, {
					id: 1,
					text: {
						da: `Diskret individuel kontakt`,
						en: ``
					}
				}),
				Object.assign({}, taskTemplates.matchTemplate.itemTemplate, {
					id: 2,
					text: {
						da: `Tydelig fælles rammesætning`,
						en: ``
					}
				}),
				Object.assign({}, taskTemplates.matchTemplate.itemTemplate, {
					id: 5,
					text: {
						da: `Anerkendende tilgang`,
						en: ``
					}
				}),
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m2-branch-late-student',
			background: 'school',
			backgroundModifier: 'classroom-8a-late',
			text: {
				da: `Du har lige fået gang i undervisningen, da døren går op og Jonas kommer ind, tyve minutter for sent, med høj energi og en energidrik i hånden: 'Sorry jeg kommer sent - måtte lige ned efter en Red Bull!' 
				<br /><br />Han går direkte mod sin plads mens han højlydt hilser på flere klassekammerater. 
				<br /><br />Hvad gør du?`,
				en: ``
			},
			maxPoints: 5,
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Fortsætter roligt undervisningen men får flettet en kommentar ind: "Jonas, telefonen i kassen og energidrikken i tasken tak"`,
								en: ``
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Stopper undervisningen og siger med et smil: "Kom nu Jonas, vi venter"`,
								en: ``
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Du stopper undervisningen er fokuserer på Jonas: "Hey Jonas - godt du er her. Aflever telefon og energidrik, så sætter jeg dig ind i hvad vi laver"`,
								en: ``
							},
							nextStepId: 'step-4',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Jonas stopper op: 'Ej come on, jeg har lige købt den!'`,
						en: ``
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Ja det er nederen, men reglerne er de samme altid, også når I har vikar`,
								en: ``
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
							],
							nextStepId: 'step-5'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2,
							text: {
								da: `Spørger højt hvad klassen synes er fair`,
								en: ``
							}, 
							nextStepId: 'step-9',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er meget risikabelt at åbne dig op for den slags diskussioner, især hvis du ikke er 100% sikker på at du har hele klassen på din side og kender klassen aldeles godt.`,
											en: ``,
										}
									})
								})
							],
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Jep, og så husk også at aflevere din telefon`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 2
								})
							],
							nextStepId: 'step-6'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-3',
					text: {
						da: `Jonas griner: "På hvad? At jeg skal drikke ud?" Flere elever griner med.`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Nej, vi venter på at du følger samme regler som resten af klassen`,
								en: ``
							}, 
							nextStepId: 'step-8'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Du vælger selv - men uden energidrik og med telefon i kassen`,
								en: ``
							}, 
							nextStepId: 'step-8'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Så må du desværre gå op på kontoret`,
								en: ``
							}, 
							nextStepId: 'step-8'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-4',
					text: {
						da: `Jonas bliver stående: "Hvorfor skal jeg det? Du er jo bare vikar..."`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Netop derfor er det endnu vigtigere at vi følger de normale regler`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du håndterer udfordringen professionelt og respektfuldt.`,
											en: ``,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Lad os ikke bruge tid på diskutere regler - vi var lige ved at have en god diskussion`,
								en: ``
							}, 
							nextStepId: 'step-8'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Hvis du ikke kan acceptere reglerne med en vikar, må jeg ringe efter skolelederen`,
								en: ``
							}, 
							nextStepId: 'step-8'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-5',
					text: {
						da: `Jonas sukker demonstrativt: "Så skal jeg vel også aflevere min telefon?"`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Ja - og så kan du være med i den diskussionen vi er i gang med`,
								en: ``
							}, 
							nextStepId: 'step-7'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Præcis, og så er du velkommen til at deltage på lige fod med de andre`,
								en: ``
							}, 
							nextStepId: 'step-7'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Det ved du godt du skal`,
								en: ``
							}, 
							nextStepId: 'step-8'
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-6',
					text: {
						da: `Jonas ruller med øjnene: "Telefonen også? Seriøst?"`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Ja, og bagefter tager vi energidrikken`,
								en: ``
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Ved at fokusere på telefonen først giver du ham mulighed for at aflevere energidrikken frivilligt bagefter`,
											en: ``,
										}
									})
								})
							], 
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-7',
					text: {
						da: `Jonas griner lidt tile et par af de andre drenge, men finder så sin plads i god ro og orden.`,
						en: ``
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-8',
					text: {
						da: `Jonas er tydligt sur og udbryder "årh slap dog af mand, kan du ikke engang tage en joke". Han lægger sin Redbull og telefon ned i sin task og tager skolematrialer frem.`,
						en: ``
					}
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-9',
					text: {
						da: `Det bliver kortvarigt en råbekonkurrence mellem to fraktioner i klassen mellem dem der er trætte og dem der gerne vil lære noget. <br /><br />Efter lidt tid får du styr på tropperne, og lader Jonas gøre hvad der passer ham, så længe du kan komme igang med at arbejde med det faglige`,
					}
				})
			]
		}),
		Object.assign({}, taskTemplates.branchingStoryTemplate.mainTemplate, {
			taskId: 's1-m2-branch-break-down',
			background: 'school',
			backgroundModifier: 'classroom-8a',
			text: {
				da: `Du er ved at forklare dagnes emne da Malthe udbryder: "Det her er alt for svært! Det er jo ikke engang noget vi skal kunne!' Flere elever nikker og mumler samtykkende."`,
				en: ``
			},
			maxPoints: 4,
			steps: [
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-1',
					text: null,
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Lad os prøve at bryde det ned i mindre dele sammen`,
								en: ``
							},
							nextStepId: 'step-2',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1,
								})
							], 
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `I har faktisk allerede lært grundprincipperne - lad os starte der`,
								en: ``
							},
							nextStepId: 'step-3',
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1,
								})
							], 
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3, 
							text: {
								da: `Okay, lad mig vise et eksempel først`,
								en: ``
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 1,
								}),
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Klassen følger med mens du demonstrerer: "Det ser faktisk lidt lettere ud nu"`,
											en: ``,
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-2',
					text: {
						da: `Flere elever ser interesserede ud, men Malthe er stadig skeptisk: "Vi plejer at gøre det på en anden måde" <br /><br /> Hvad siger du?`,
						en: ``
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Fortæl mig om jeres måde - så kombinerer vi det måske`,
								en: ``
							},
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'points',
									value: 3
								}),
							],
							nextStepId: 'step-4'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2,
							text: {
								da: `Lad os prøve jeres måde først, så bygger vi videre`,
								en: ``
							}, 
							nextStepId: 'step-5'
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Vi kan altid gå tilbage til basis hvis det bliver for svært`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Du har ikke heelt styr på de grundlæggende ting altid, men ved klassens hjælp får I styr på det basale, og så får næsten styr på det som timen egentlig handlede om, lige inden timen slutter.`,
											en: ``,
										}
									})
								})
							],
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-3',
					text: {
						da: `Ja, men det her ser helt anderledes ud den måde du laver det på!`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det gør det - lad os finde ligheder og forskelle sammen`,
								en: ``
							}, 
							nextStepId: 'step-6'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-4',
					text: {
						da: `Malthe og et par andre begynder at forklare deres normale metode`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Det lyder smart. Skal vi prøve at bruge jeres metode først og så bygge videre?`,
								en: ``
							}, 
							nextStepId: 'step-5'
						}),
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceTemplate, {
					id: 'step-5',
					text: {
						da: `Klassen bliver mere engageret, men en elev spørger: "Hvad hvis vi stadig ikke kan?"`
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Så tager vi det sammen skridt for skridt`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Din rolige tilgang hjælper, Og du får skabt en god stemning resten af timen.`,
											en: ``,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Det finder vi ud af - jeg lover at hjælpe`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Din rolige tilgang hjælper, Og du får skabt en god stemning resten af timen.`,
											en: ``,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Vi kan altid gå tilbage til basis hvis det bliver for svært`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Din rolige tilgang hjælper, Og du får skabt en god stemning resten af timen.`,
											en: ``,
										}
									})
								})
							]
						})
					]
				}),
				Object.assign({}, taskTemplates.branchingStoryTemplate.stepInfoTemplate, {
					id: 'step-6',
					text: {
						da: `Nogle begynder at se forbindelser fra det kendte til det nye, andre er stadig usikre <br /><br />Hvad siger du?`,
						en: ``
					},
					options: [
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 1, 
							text: {
								da: `Lad os skrive alle lighederne op på tavlen`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det kan være en god idé at visualisere koncepter. Du skal bare også huske at få klassen med i visualiseringsøvelsen. <br /><br />I bruger tiden på at arbejde med begreberne i plenum. Nogle af de stærke elever ser lidt tætte ud ved at snakke om det igen og igen.`,
											en: ``,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 2, 
							text: {
								da: `Prøv at forklare det til hinanden i grupper`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det kan være en god idé at benytte grupper. Du skal blot sikre dig at der er forskellige kompetencer til stede i grupperne, ellers kan det være svært at få et højt fagligt niveau. <br /><br />Efter 4 minutters gruppesnak, er der lidt opbrudsstemning. Du vurderer at det bedst du kan klare nu er repetition af kendt stof. Du beder eleverne om at gå ind på en matematik-opgaveportal og lave opgaver resten af timen.`,
											en: ``,
										}
									})
								})
							]
						}),
						Object.assign({}, taskTemplates.branchingStoryTemplate.stepMultipleChoiceOptionTemplate, {
							id: 3,
							text: {
								da: `Er der nogen der synes de har forstået det, der har lyst til at prøve at forklare det?`,
								en: ``
							}, 
							effects: [
								Object.assign({}, effectTemplate.mainTemplate, {
									type: 'feedback',
									feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
										text: {
											da: `Det er en god idé at inddrage klassen, på den måde kan du skabe en fælles fortælling om det faglige, og de stærke elever der har forstået det, føler ikke de spilder deres tid. <br /><br />I bruger tiden på en god bred diskussion, som ender med at de fleste føler de har forsået meget mere end da timen startede.`,
											en: ``,
										}
									})
								})
							]
						})
					]
				})
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m2-mc-snacks',
			background: 'school',
			backgroundModifier: 'teachers-room-left',
			characterId: 'test',
			isDilemma: true,
			text: {
				da: `Efter timen går du forbi personalerummet.
					<br /><br />Du taler med den imødekommende lærer fra i morges. "Hvordan gik dine timer med 8.A?"
					<br /><br />Hvad svarer du?`,
				en: ``,
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `"Det gik fint - de skulle bare lige i gang."`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Du anerkender at det var lidt hårdt i starten.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `"Jeg havde en udfordring med en elev, der afleverede en ekstra telefon og en der kom meget sent til timen. Fik løst begge dele, men synes det er udfordrende."`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er en styrke at du viser at det kan være svært. Det gør det også nemmere for andre at hjælpe dig.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `"Klassen var OK, men der var enkelte elever, som gjorde det svært at komme i gang."`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Man skal passe på med at hænge enkelte elever ud, men du holder det til generelle termer og viser at det har været udfordrende.`,
									en: ``,
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
			taskId: 's1-m2-mc-rapport',
			background: 'school',
			backgroundModifier: 'teachers-room-right',
			isDilemma: true,
			maxPoints: 1,
			text: {
				da: `Du skal udfylde vikarsedlen og give tilbagemelding i Aula. Hvad prioriterer du at videregive?`,
				en: ``,
			},
			options: [
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 1,
					text: {
						da: `Fokuserer på de konkrete hændelser der kræver opfølgning`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det kan være en god idé at sørge for at få fortalt om de specifikke situationer, så læreren kan håndtere det hvis der skulle opstå noget lignende i de følgende dage.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 2,
					text: {
						da: `Skriver primært om det faglige arbejde i klasserne`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er fint at fortælle hvad I har nået, men sørg også for at fortæl om hvad der er sket af sociale ting og eventuelle problemer.`,
									en: ``,
								}
							})
						})
					]
				}),
				Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
					id: 3,
					text: {
						da: `Laver en generel beskrivelse af dagens forløb`,
						en: ``
					},
					effects: [
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'points',
							value: 1
						}),
						Object.assign({}, effectTemplate.mainTemplate, {
							type: 'feedback',
							feedback: Object.assign({}, effectTemplate.feedbackTemplate, {
								text: {
									da: `Det er fint at være overordnet, men sørg også for at fortæl om hvad der er sket af sociale ting og eventuelle problemer.`,
									en: ``,
								}
							})
						})
					]
				}),
			]
		}),
		Object.assign({}, taskTemplates.instructionsTemplate.mainTemplate, {
			taskId: 's1-m2-instructions-done',
			background: 'home',
			backgroundModifier: 'park-return',
			text: {
				da: `På cykelturen hjem tænker du over dagen. Det var udfordrende, og flere situationer kunne være håndteret bedre. Men du kom igennem det, og ved nu mere om hvad du skal være opmærksom på næste gang. Du bruger cykelturen til at reflektere over dagen og er klar til i morgen.`,
			},
			textPassed: {
				da: `På cykelturen hjem tænker du over dagen. Det gik faktisk rigtig godt! Du fik håndteret de svære situationer professionelt, skabte god kontakt med eleverne og holdt et godt fagligt niveau.`
			}
		}),

];

let taskIdsArr = [];
moduleTasks.forEach((task, index) => {
	task.id = 's1-m2-' + (index + 1 < 10 ? '0' : '') + (index + 1);
	
	/* Check taskId is set when required and unique */
	if (task.isSolveToContinue) {
		if (task.taskId) {
			if (taskIdsArr.indexOf(task.taskId) >= 0) {
				console.error('Task id not unique: ', task.taskId);
			} else {
				taskIdsArr.push(task.taskId);
			}
		} else {
			console.error('Missing task id for task: ', task);
		}
	}
});


export {
	moduleTasks
};